// Import our custom CSS
import './style/page.scss'
import './style/fullscreen.scss'

const ANALYTICS_OPT_IN_LABEL = "analyticsOptIn";

document.addEventListener("scroll", function () {
    let button = document.getElementById("goToTopButton");
    if (button) {
        button.style.display = (document.body.scrollTop > 20 || document.documentElement.scrollTop > 20) ? "initial" : "none";
    }
});

document.addEventListener("readystatechange", function () {
    if (document.readyState == "complete") {
        let button = document.getElementById("goToTopButton");
        if (button) {
            button.addEventListener("click", function () {document.documentElement.scrollTop = 0;});
        }
        document.getElementById("saveCookieSettings")?.addEventListener("click", handleCookieButtonClicked);
        if (document.getElementById("cookieBanner")) {
            if (typeof(getOptInCookieValue()) === "undefined") {
                document.getElementById("cookieBanner").style.display = "";
            } else {
                document.getElementById("cookieBanner").style.display = "none";
            }
        }

        if (document.location.search?.includes("hrobId=")) {
            setTimeout(() => {
                document.querySelector("#karta-tab-content .tab-content")?.scrollIntoView({behavior: 'smooth'});
            }, 500);
        }

        document.getElementById("pullUpTab")?.addEventListener("click", function () {            
            document.getElementById("karta").classList.add("fullscreen-expanded");
            recalculateCardPosition();
        });
        document.getElementById("pullDownTab")?.addEventListener("click", function () {
            document.getElementById("karta").classList.remove("fullscreen-expanded");
            recalculateCardPosition();
        });
        document.querySelectorAll("#karta a[data-bs-toggle='tab']").forEach((link) => {
            link.addEventListener("shown.bs.tab", function () {
                recalculateCardPosition();
            });
        });
        document.getElementById("copyrightLink")?.addEventListener("click", handleCopyrightLinkClicked);
    }
});

function handleCookieButtonClicked() {
    let analyticsOptIn = (document.getElementById("analyticalCookies") as HTMLInputElement).checked;
    let expiryDate = new Date();
    expiryDate.setTime(expiryDate.getTime() + (30*24*60*60*1000));
    document.cookie = ANALYTICS_OPT_IN_LABEL+"="+analyticsOptIn+";expires="+expiryDate.toUTCString()+";";
    gtag("consent", "update", { analytics_storage: (analyticsOptIn ? "granted" : "denied")});
    document.getElementById("cookieBanner").style.display = "none";
}

function getOptInCookieValue() {
    let cookieValues = decodeURIComponent(document.cookie).split(";");
    let value = cookieValues.find(c => c.trim().startsWith(ANALYTICS_OPT_IN_LABEL+"="));
    if (value) {
        return value.trim().replace(ANALYTICS_OPT_IN_LABEL+"=", "") == "true";
    }
    return undefined;
}

function handleCopyrightLinkClicked() {
    document.getElementById("copyrightLink")?.classList.remove("fake-link");
    document.getElementById("copyrightDetails")?.classList.remove("karta-collapsed");
}

export function recalculateCardPosition() {
    if (document.fullscreenElement) {
        if (document.getElementById("karta").classList.contains("fullscreen-expanded")) {
            let offset = document.getElementById("karta-tab-content").scrollHeight + 70;
            document.getElementById("karta").style.top = Math.max(0, window.innerHeight-offset)+"px";
            return;
        }
    }
    document.getElementById("karta").style.top = "";
}